var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMucPriceButtons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 18,
    viewBox: "0 0 93 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 17,
    x: 0.5,
    y: 0.5,
    fill: "#FFF",
    stroke: "#D8D8D8",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M23 0H24V18H23zM46 0H47V18H46zM69 0H70V18H69z"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000",
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontSize: 5,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 4.405,
    y: 11
  }, "OCOU")), /*#__PURE__*/React.createElement("text", {
    fill: "#000",
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontSize: 5,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 30.872,
    y: 8
  }, "SIM"), /*#__PURE__*/React.createElement("tspan", {
    x: 30.455,
    y: 14
  }, "Low")), /*#__PURE__*/React.createElement("text", {
    fill: "#000",
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontSize: 5,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 53.373,
    y: 8
  }, "SIM"), /*#__PURE__*/React.createElement("tspan", {
    x: 48.377,
    y: 14
  }, "Medium")), /*#__PURE__*/React.createElement("text", {
    fill: "#000",
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontSize: 5,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 76.373,
    y: 8
  }, "SIM"), /*#__PURE__*/React.createElement("tspan", {
    x: 75.493,
    y: 14
  }, "High")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMucPriceButtons);
export default __webpack_public_path__ + "static/media/muc-price-buttons.a012ede47b7f0d067ddd4caca4c45427.svg";
export { ForwardRef as ReactComponent };